import React from 'react';

import { usePromoDiscount } from '../../Promo';

export const withPromoHOC = (Component) => (props) => {
  const promo = usePromoDiscount(props);

  return <Component {...props} promo={promo} />;
};
